var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md:w-1/3"},[_c('div',{staticClass:"flex flex-col pl-6"},[_c('PaymentMethod'),_vm._v(" "),_c('PaymentSummary',{attrs:{"membership-uuid":_vm.membershipUuid}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }